"use client";

import { useRef } from "react";
import WhatsAppCTA from "./ui/button";
import Card from "./differentials/card";
import { motion } from "framer-motion";

export default function WhatWeOfferSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  const blocks = [
    {
      title: "Consultorias",
      icon: "Zap",
      items: [
        "Transforme sua empresa em um negócio mais inovador e tecnológico.",
        "Diagnóstico completo do seu CRM, clientes e concorrência.",
        "Plano de marketing personalizado e escolha das melhores tecnologias.",
        "Acompanhamento na implementação de soluções práticas e inovadoras.",
      ],
    },
    {
      title: "Cursos e Palestras",
      icon: "BookOpen",
      items: [
        "Marketing sensorial, experiencial e de luxo.",
        "Turismo e tecnologia.",
        "Comportamento do consumidor digital.",
        "Excelência no atendimento, escapismo, etiqueta, hospitalidade e inovação.",
      ],
    },
    {
      title: "Inteligência Artificial",
      icon: "Cpu",
      items: [
        "Vídeos animados em formato de avatar realista.",
        "Soluções criativas para marketing, treinamento e experiência do cliente.",
      ],
    },
  ];

  return (
    <section
      id="servicos"
      ref={sectionRef}
      className="py-20 px-6 md:px-12 lg:px-24 bg-gray-50"
    >
      <div className="mx-auto text-center mb-12 max-w-7xl">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-blue-700 mb-2"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
        >
          O Que Oferecemos
        </motion.h2>
        <motion.p
          className="text-gray-600 text-base md:text-lg"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Conheça nossos serviços pensados para transformar sua empresa e sua
          experiência com clientes.
        </motion.p>
      </div>

      <div className="grid md:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {blocks.map(({ title, icon, items }, index) => (
          <Card
            key={index}
            icon={icon}
            title={title}
            description={items}
            index={index}
          />
        ))}
      </div>
      <div className="flex mt-8">
        <WhatsAppCTA />
      </div>
    </section>
  );
}
